import React, {useState, useEffect} from 'react';
import {Radio} from 'antd';
import {ChevronDown, ChevronUp, Eye, X} from 'lucide-react';
import './ThemeS2P.scss';
import {images} from '../../../../constants';

const themes = [
    {
        id: 'theme1',
        key: 'light',
        image: images.s2pLightTheme,
    },
    {
        id: 'theme2',
        key: 'dark',
        image: images.s2pDarkTheme,
    },
    {
        id: 'theme3',
        key: 'cream',
        image: images.s2pCreamTheme,
    },
];

const ThemeS2P = ({t, onThemeChange, currentTheme = null}) => {
    const [selectedTheme, setSelectedTheme] = useState(null);
    const [collapsed, setCollapsed] = useState(false);
    const [previewTheme, setPreviewTheme] = useState(null);

    useEffect(() => {
        if (currentTheme) {
            const matched = themes.find(t => t.key.toLowerCase() === currentTheme.toLowerCase());
            if (matched) {
                setSelectedTheme(matched.id);
            }
        }
    }, [currentTheme]);

    const handleSelect = (id) => {
        setSelectedTheme(id);
        const selected = themes.find((t) => t.id === id);
        if (onThemeChange && selected) {
            onThemeChange(selected.key);
        }
    };

    const toggleCollapse = () => {
        setCollapsed((prev) => !prev);
    };

    return (
        <div className={`theme-selector-container ${collapsed ? 'is-collapsed' : ''}`}>
            <div className="collapse-toggle" onClick={toggleCollapse}>
                <span>{collapsed ? 'See themes' : 'Hide themes'}</span>
                {collapsed ? <ChevronDown size={20}/> : <ChevronUp size={20}/>}
            </div>

            <div className="collapsible-wrapper">
                <div className="themes-wrapper">
                    {themes.map((theme) => (
                        <div className="theme-row" key={theme.id}>
                            <img
                                src={theme.image}
                                alt={theme.title}
                                className="theme-image"
                                onClick={() => handleSelect(theme.id)}
                                style={{cursor: 'pointer'}}/>
                            <div className="theme-info">
                                <Radio.Group
                                    onChange={() => handleSelect(theme.id)}
                                    value={selectedTheme === theme.id ? theme.id : null}
                                >
                                    <Radio value={theme.id}>{t(`pages.user.profile.s2pTheme.${theme.key}`)}</Radio>
                                </Radio.Group>
                                <button
                                    className="theme-preview-button"
                                    type="button"
                                    onClick={() => setPreviewTheme(theme)}
                                >
                                    <Eye size={14}/>
                                    <span>Preview</span>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {previewTheme ? (
                <div className="theme-preview-overlay" onClick={() => setPreviewTheme(null)}>
                    <button
                        className="theme-preview-close"
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            setPreviewTheme(null);
                        }}
                    >
                        <X size={22}/>
                    </button>
                    <img
                        src={previewTheme.image}
                        alt={t(`pages.user.profile.s2pTheme.${previewTheme.key}`)}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default ThemeS2P;
